import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {HttpService} from './http.service';

@Injectable()
export class CurrenciesApi {
    private readonly apiController: string = '/api/currencies';

    constructor(private api: HttpService) {
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        const params = new HttpParams()
            .set('page', `${pageNumber}`)
            .set('pageSize', `${pageSize}`)
            .set('search', `${search}`)
            .set('order', `${orderBy}`);

        return this.api.get(this.apiController, {params}).pipe(map((data) => data));
    }

    get(id: number): Observable<any> {
        return this.api.get(`${this.apiController}/${id}`)
            .pipe(map(data => {
                return {...data};
            }));
    }

    add(item: any): Observable<any> {
        return this.api.post(`${this.apiController}`, item);
    }

    update(item: any): Observable<any> {
        // Extraer el id para la URL (manejar tanto 'id' como 'ID')
        const id = item.id !== undefined ? item.id : (item.ID !== undefined ? item.ID : null);
        // Validar que el id existe y no es null
        if (!id || id === null || id === 'null') {
            throw new Error('No se puede actualizar una moneda sin ID. Use el método add() para crear una nueva moneda.');
        }
        // Crear un objeto sin el id para el body, ya que el backend lo obtiene de la URL
        const { id: _, ID: __, ...body } = item;
        return this.api.put(`${this.apiController}/${id}`, body);
    }

    delete(item: any): Observable<any> {
        // Extraer el id para la URL (manejar tanto 'id' como 'ID')
        const id = item.id !== undefined ? item.id : (item.ID !== undefined ? item.ID : null);
        // Validar que el id existe y no es null
        if (!id || id === null || id === 'null') {
            throw new Error('No se puede eliminar una moneda sin ID.');
        }
        return this.api.delete(`${this.apiController}/${id}`);
    }
}

